import list from './list'

const diseases =
{
    ...list,
    helmet :
    {
        title : 'Maladies' ,
        metas : []
    },
    empty  : 'Aucune maladie trouvée',
    search : 'Rechercher une maladie...' ,
    title  : 'Maladies'
};

export default diseases ;
